const darkTextIntents = new Set([
  'dhl',
  'mm',
  'russianpostru',
  'secondary',
  'yandex-market',
  'pickup',
])

export const getAdaptiveStripeBackground = (intent?: string | null) => {
  const stripeColor = darkTextIntents.has(intent ?? '')
    ? 'rgba(36, 36, 36, 0.12)'
    : 'rgba(255, 255, 255, 0.18)'

  return `repeating-linear-gradient(-45deg, ${stripeColor} 0, ${stripeColor} 5px, transparent 5px, transparent 10px)`
}
